export default __webpack_public_path__ + "static/media/cam-front.593e25b2.svg";